/**
 * PDP cart confirmation — latest add clarity for Single + mixed bundles.
 */
(function () {
  'use strict';

  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function getCartStrings() {
    return window.cartStrings || {};
  }

  function normalizeAddedItems(items) {
    if (!items || !items.length) return [];

    return items
      .map(function (item) {
        if (!item) return null;
        var title = (item.title || item.variantTitle || item.variant_title || '').trim();
        var qty = parseInt(item.quantity, 10);
        if (Number.isNaN(qty) || qty < 1) qty = 1;
        if (!title) return null;
        return { title: title, quantity: qty };
      })
      .filter(function (item) {
        return item != null;
      });
  }

  function buildAddedItemsFromResponse(cartData) {
    if (!cartData) return [];

    if (Array.isArray(cartData.items) && cartData.items.length) {
      return normalizeAddedItems(
        cartData.items.map(function (item) {
          return {
            title: item.variant_title || item.title,
            quantity: item.quantity || 1,
          };
        })
      );
    }

    if (cartData.variant_title || cartData.title) {
      return normalizeAddedItems([
        {
          title: cartData.variant_title || cartData.title,
          quantity: cartData.quantity || 1,
        },
      ]);
    }

    return [];
  }

  function formatItemLine(item) {
    if (item.quantity > 1) {
      return item.title + ' \u00d7 ' + item.quantity;
    }
    return item.title;
  }

  function getProductTitle() {
    var titleEl = qs('[data-pdp-hero-title]');
    if (titleEl && titleEl.textContent.trim()) return titleEl.textContent.trim();

    var stickyTitle = qs('[data-pdp-sticky-title]');
    if (stickyTitle && stickyTitle.textContent.trim()) return stickyTitle.textContent.trim();

    return '';
  }

  function getTotalQuantity(addedItems) {
    return addedItems.reduce(function (total, item) {
      return total + item.quantity;
    }, 0);
  }

  function summarizeAddedItems(addedItems) {
    var map = Object.create(null);
    var order = [];

    addedItems.forEach(function (item) {
      if (!item || !item.title) return;
      var key = item.title;
      if (!map[key]) {
        map[key] = {
          title: item.title,
          quantity: 0,
        };
        order.push(key);
      }
      map[key].quantity += item.quantity;
    });

    return order.map(function (key) {
      return map[key];
    });
  }

  function buildHeadingMessage(addedItems) {
    var strings = getCartStrings();
    var count = getTotalQuantity(addedItems);

    if (count > 1) {
      return count + ' items added to your cart';
    }

    return strings.itemAdded || 'Item added to your cart';
  }

  function buildDetailMessage(addedItems) {
    if (!addedItems.length) return '';

    if (addedItems.length === 1) {
      return 'Added: ' + formatItemLine(addedItems[0]);
    }

    return 'Added: ' + addedItems.map(formatItemLine).join(', ');
  }

  function preserveIconUpdateHeading(heading, message) {
    if (!heading) return;

    var icon = heading.querySelector('svg');
    if (icon) {
      heading.innerHTML = '';
      heading.appendChild(icon.cloneNode(true));
      heading.appendChild(document.createTextNode(' ' + message));
      return;
    }

    var iconWrapper = heading.querySelector('.svg-wrapper');
    if (iconWrapper) {
      heading.innerHTML = '';
      heading.appendChild(iconWrapper.cloneNode(true));
      heading.appendChild(document.createTextNode(' ' + message));
      return;
    }

    heading.textContent = message;
  }

  function removeExistingNotices() {
    document.querySelectorAll('[data-pdp-cart-added-notice]').forEach(function (node) {
      node.remove();
    });
  }

  function buildNoticeElement(addedItems) {
    var productTitle = getProductTitle();
    var summarizedItems = summarizeAddedItems(addedItems);
    var notice = document.createElement('div');
    notice.className = 'pdp-cart-added-notice';
    notice.setAttribute('data-pdp-cart-added-notice', '');
    notice.setAttribute('role', 'status');

    var heading = document.createElement('p');
    heading.className = 'pdp-cart-added-notice__heading';
    heading.textContent = buildHeadingMessage(addedItems);
    notice.appendChild(heading);

    if (productTitle && getTotalQuantity(addedItems) > 1) {
      var product = document.createElement('p');
      product.className = 'pdp-cart-added-notice__product';
      product.textContent = productTitle;
      notice.appendChild(product);
    }

    var list = document.createElement('ul');
    list.className = 'pdp-cart-added-notice__list';

    summarizedItems.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'pdp-cart-added-notice__item';
      li.textContent = formatItemLine(item);
      list.appendChild(li);
    });

    notice.appendChild(list);
    return notice;
  }

  function updateDrawerAddedNotice(addedItems) {
    if (!addedItems.length) return;

    var cartItems = document.getElementById('CartDrawer-CartItems');
    if (!cartItems) return;

    removeExistingNotices();

    var wrapper = cartItems.querySelector('.drawer__cart-items-wrapper');
    if (!wrapper) return;

    wrapper.insertBefore(buildNoticeElement(addedItems), wrapper.firstChild);
  }

  function updateNotificationProductPreview(addedItems) {
    var target = document.getElementById('cart-notification-product');
    if (!target || !addedItems.length) return;

    target.innerHTML = '';
    target.classList.add('cart-notification-product--pdp-summary');

    var productTitle = getProductTitle();
    var totalQuantity = getTotalQuantity(addedItems);
    var summarizedItems = summarizeAddedItems(addedItems);

    if (totalQuantity > 1) {
      var row = document.createElement('div');
      row.className = 'cart-item pdp-cart-added-preview pdp-cart-added-preview--summary';
      row.id = 'cart-notification-product-pdp-summary';

      var copy = document.createElement('div');
      copy.className = 'pdp-cart-added-preview__copy';

      if (productTitle) {
        var product = document.createElement('h3');
        product.className = 'cart-notification-product__name h4 pdp-cart-added-preview__product';
        product.textContent = productTitle;
        copy.appendChild(product);
      }

      var variants = document.createElement('p');
      variants.className = 'pdp-cart-added-preview__variants';
      variants.textContent = summarizedItems.map(formatItemLine).join(' \u00b7 ');
      copy.appendChild(variants);

      row.appendChild(copy);
      target.appendChild(row);
      return;
    }

    summarizedItems.forEach(function (item, index) {
      var row = document.createElement('div');
      row.className = 'cart-item pdp-cart-added-preview';
      row.id = 'cart-notification-product-pdp-' + index;

      var copy = document.createElement('div');
      copy.className = 'pdp-cart-added-preview__copy';
      var name = document.createElement('h3');
      name.className = 'cart-notification-product__name h4';
      if (productTitle && item.title && item.title !== productTitle) {
        name.textContent = productTitle + ' \u00b7 ' + formatItemLine(item);
      } else {
        name.textContent = formatItemLine(item);
      }
      copy.appendChild(name);
      row.appendChild(copy);
      target.appendChild(row);
    });
  }

  function updateLiveRegion(detailMessage, headingMessage) {
    var liveRegion =
      document.getElementById('CartDrawer-LiveRegionText') ||
      document.getElementById('cart-live-region-text');

    if (liveRegion) {
      liveRegion.textContent = detailMessage || headingMessage;
    }
  }

  function refreshConfirmation(payload) {
    if (!payload) return;

    var addedItems = normalizeAddedItems(payload.addedItems);
    if (!addedItems.length && payload.cartData) {
      addedItems = buildAddedItemsFromResponse(payload.cartData);
    }

    if (!addedItems.length) return;

    var headingMessage = buildHeadingMessage(addedItems);
    var detailMessage = buildDetailMessage(addedItems);

    var notification = document.getElementById('cart-notification');
    if (notification) {
      notification.setAttribute('aria-label', detailMessage || headingMessage);
    }

    preserveIconUpdateHeading(qs('.cart-notification__heading'), headingMessage);
    updateNotificationProductPreview(addedItems);
    updateDrawerAddedNotice(addedItems);
    updateLiveRegion(detailMessage, headingMessage);
  }

  function resolveAddedQuantity(payload, addedItems) {
    if (addedItems && addedItems.length) {
      return addedItems.reduce(function (total, item) {
        return total + item.quantity;
      }, 0);
    }

    if (!payload) return 1;

    var explicit = parseInt(payload.addedQuantity, 10);
    if (!Number.isNaN(explicit) && explicit > 0) return explicit;

    var cartData = payload.cartData;
    if (cartData && Array.isArray(cartData.items) && cartData.items.length) {
      return cartData.items.reduce(function (total, item) {
        return total + (item.quantity || 1);
      }, 0);
    }

    if (cartData && typeof cartData.quantity === 'number' && cartData.quantity > 0) {
      return cartData.quantity;
    }

    return 1;
  }

  function handleCartUpdate(payload) {
    if (!payload || !payload.source) return;

    if (payload.source !== 'pdp-framework' && payload.source !== 'pdp-purchase-options-cart') {
      return;
    }

    refreshConfirmation(payload);
  }

  function initCartConfirmation() {
    if (document.documentElement.dataset.pdpCartConfirmationInit === 'true') return;
    document.documentElement.dataset.pdpCartConfirmationInit = 'true';

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    }
  }

  window.PdpCartConfirmation = {
    refresh: refreshConfirmation,
    buildAddedItemsFromResponse: buildAddedItemsFromResponse,
    resolveAddedQuantity: resolveAddedQuantity,
  };

  if (document.readyState !== 'loading') initCartConfirmation();
  else document.addEventListener('DOMContentLoaded', initCartConfirmation, { once: true });
})();
